import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../../../shared/Header/Header';
import imprivataIcon from '../Icons/imprivata.svg';
import proximityCardIcon from '../Icons/proximityCard.svg';
import proximityCardIconSmall from '../Icons/proximityCardSmall.svg';
import './ProximityCard.scss';
import Logout from '../../../shared/Logout/Logout';

/**
 * ProximityCard prompt for login
 * @class ProximityCard
 * @extends {Component}
 */
class ProximityCard extends Component {
  static propTypes = {
    /** Header title */
    headerTitle: PropTypes.string,
    /** Header image (small icon for header) */
    headerImage: PropTypes.string,
    /** Reader image (large icon for body) */
    readerImage: PropTypes.string,
    /** Message title */
    messageTitle: PropTypes.string,
    /** Message details */
    messageDetails: PropTypes.string,
    /** The component to be used for logout */
    logoutComponent: PropTypes.object,
    /** link to display more options */
    moreOptionsLink: PropTypes.object,
    /** The DOM tree/component to be used for the footer */
    footer: PropTypes.object,
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
  };

  static defaultProps = {
    headerTitle: 'Log in',
    headerImage: proximityCardIconSmall,
    readerImage: proximityCardIcon,
    messageTitle: 'Tap your card to login',
    messageDetails: '',
    logoutComponent: <Logout />,
    moreOptionsLink: null,
    footer: <img className='Footer' src={imprivataIcon} alt='logo' />,
    useCustomUX: false,
  };

  render() {
    return (
      <div className='CIDRA'>
        {this.props.logoutComponent}
        {this.props.useCustomUX ? (
          <Header />
        ) : (
          <div className='Header-Box'>
            <img src={this.props.headerImage} className='Modality-Icon' alt='proximity card' />
            <div className='Header-Text'>
              <span>{this.props.headerTitle}</span>
            </div>
          </div>
        )}
        <div className='login-container'>
          <div className='wait-content'>
            <div className='message-container'>
              <div className='message-title'>{this.props.messageTitle}</div>
              {this.props.messageDetails && (
                <div className='message-details'>{this.props.messageDetails}</div>
              )}
            </div>
            <img src={this.props.readerImage} className='proximity-card-icon' alt='proximity card reader' />
          </div>
          {this.props.moreOptionsLink && (
            <div className='more-options-container'>
              {this.props.moreOptionsLink}
            </div>
          )}
        </div>
        <hr className='Footer-hr' />
        {this.props.footer}
      </div>
    );
  }
}

export default ProximityCard;
